export type SecurityContext = "public" | "authenticated";

export function isSecurityContext(value: string): value is SecurityContext {
    return value === "public" || value === "authenticated";
}
